
/**
 * Returns Date in the current timezone
 * @param {*} date 
 * @returns 
 */
function toLocal() {
  var date = new Date();
  var local = new Date(date);
  local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return local.toJSON().slice(0, 10);
}

export default toLocal;